(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jj-cart-addons"]) return;
  try {
    
(() => {
  const normalise = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  function recommendations(cart, products) {
    const items = cart.items || [];
    if (!items.some(item => item.requires_shipping) || items.some(item =>
      /bundle|collection|starter kit|mystery|advent|subscription|\bedit\b/i.test(item.product_title + ' ' + item.product_type) ||
      item.item_components?.length || item.parent_relationship || item.selling_plan_allocation ||
      Object.entries(item.properties || {}).some(([key, value]) => /part of|bundle/i.test(key + ' ' + value)))) return [];
    const existing = new Set(items.map(item => String(item.product_id)));
    const binders = items.filter(item => /binder|planner pad/i.test(item.product_title || ''));
    return products.flatMap(product => {
      if (existing.has(String(product.id)) || !product.variants.length) return [];
      if (product.colourMatch) {
        const variant = product.variants.find(option => binders.some(item => normalise(item.variant_title).includes(normalise(option.title))));
        return variant ? [{ product, variant, matched: true }] : [];
      }
      return [{ product, variant: product.variants.length === 1 ? product.variants[0] : null, matched: false }];
    }).sort((a, b) => Number(b.matched) - Number(a.matched)).slice(0, 2);
  }

  function start() {
    const configNode = document.querySelector('[data-jj-addons-config]');
    const template = document.getElementById('jj-addons-panel-template');
    if (!configNode || !template || configNode.dataset.started) return;
    configNode.dataset.started = 'true';
    const config = JSON.parse(configNode.textContent);
    const panels = new Map();
    const subscribers = new Set();
    let cart = null;
    let request = null;
    let timer;
    let adding = false;
    let queuedRefresh = false;
    let rootObserver;
    let observedRoot;
    const money = price => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: config.currency }).format(price / 100);
    const make = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    async function getCart() {
      const response = await fetch(config.root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error(config.strings.error);
      return response.json();
    }
    function drawerRoot() {
      const element = document.getElementById('upCart');
      return element?.shadowRoot || element;
    }
    function mount(context, anchor, before) {
      if (!anchor) return;
      let panel = panels.get(context);
      if (!panel) {
        panel = document.createElement('jj-cart-addons');
        panel.dataset.context = context;
        panel.hidden = true;
        panel.attachShadow({ mode: 'open' }).append(template.content.cloneNode(true));
        panel.shadowRoot.querySelector('h2').textContent = config.strings.heading;
        panel.shadowRoot.querySelector('.intro').textContent = config.strings.intro;
        panels.set(context, panel);
      }
      if (!panel.isConnected) {
        if (before) anchor.before(panel);
        else anchor.after(panel);
      }
    }
    function mountPanels() {
      const root = drawerRoot();
      const items = root?.querySelector('.upcart-public-cart-items');
      mount('drawer', items, false);
      mount('page', document.querySelector('form.cart-page .cart-footer'), true);
      if (root && observedRoot !== root) {
        rootObserver?.disconnect();
        observedRoot = root;
        rootObserver = new MutationObserver(records => {
          if (records.some(record => Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(node => node.nodeType === 1 && node.tagName !== 'JJ-CART-ADDONS'))) {
            mountPanels();
            if (cart) render();
          }
        });
        rootObserver.observe(root, { childList: true, subtree: true });
      }
    }
    function render() {
      if (!cart || adding) return;
      const choices = recommendations(cart, config.products);
      for (const [context, panel] of panels) {
        if (!panel.isConnected) continue;
        const fingerprint = JSON.stringify(choices.map(choice => [choice.product.id, choice.variant?.id, choice.product.variants.map(variant => variant.id)]));
        panel.hidden = choices.length === 0;
        if (panel.dataset.fingerprint === fingerprint) continue;
        panel.dataset.fingerprint = fingerprint;
        const list = panel.shadowRoot.querySelector('.cards');
        list.replaceChildren();
        for (const choice of choices) {
          const { product, matched } = choice;
          let selected = choice.variant;
          const card = make('article');
          const pictureLink = make('a');
          pictureLink.href = product.url;
          pictureLink.tabIndex = -1;
          pictureLink.setAttribute('aria-hidden', 'true');
          const img = make('img');
          img.alt = '';
          img.width = 64;
          img.height = 64;
          img.loading = 'lazy';
          img.src = selected?.image || product.image;
          pictureLink.append(img);
          const details = make('div', 'details');
          const title = make('h3');
          const link = make('a', '', product.title);
          link.href = product.url + (selected ? '?variant=' + selected.id : '');
          title.append(link);
          details.append(title);
          const controls = make('div', 'controls');
          const price = make('span', 'price', money((selected || product.variants[0]).price));
          const button = make('button', '', config.strings.add);
          button.type = 'button';
          const update = () => {
            button.disabled = !selected;
            button.setAttribute('aria-label', config.strings.add + ' ' + product.title + (selected && selected.title !== 'Default Title' ? ' — ' + selected.title : ''));
            if (selected) {
              price.textContent = money(selected.price);
              img.src = selected.image || product.image;
              link.href = product.url + '?variant=' + selected.id;
              pictureLink.href = link.href;
            }
          };
          if (matched) details.append(make('p', 'match', config.strings.match), make('p', 'variant', selected.title));
          else if (product.variants.length > 1) {
            const select = make('select');
            select.setAttribute('aria-label', config.strings.choose + ' — ' + product.title);
            const placeholder = make('option', '', config.strings.choose);
            placeholder.value = '';
            select.append(placeholder);
            product.variants.forEach(variant => {
              const option = make('option', '', variant.title + ' — ' + money(variant.price));
              option.value = String(variant.id);
              select.append(option);
            });
            select.addEventListener('change', () => {
              selected = product.variants.find(variant => String(variant.id) === select.value);
              update();
            });
            details.append(select);
          } else if (selected.title !== 'Default Title') details.append(make('p', 'variant', selected.title));
          controls.append(price, button);
          details.append(controls);
          card.append(pictureLink, details);
          list.append(card);
          update();
          button.addEventListener('click', async event => {
            event.preventDefault();
            event.stopPropagation();
            if (!selected || adding) return;
            adding = true;
            button.disabled = true;
            button.textContent = config.strings.adding;
            const status = panel.shadowRoot.querySelector('.status');
            status.replaceChildren();
            let succeeded = false;
            try {
              const latest = await getCart();
              if (!recommendations(latest, config.products).some(choice => choice.product.id === product.id)) {
                cart = latest;
                return;
              }
              const response = await fetch(config.root + 'cart/add.js', {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: selected.id, quantity: 1, properties: { _jj_cart_addon: 'matching-accessories-v1' } }] })
              });
              if (!response.ok) {
                if (response.status === 422) product.variants = product.variants.filter(variant => variant.id !== selected.id);
                throw new Error(config.strings.error);
              }
              succeeded = true;
              status.textContent = config.strings.added;
              if (context === 'page' || typeof window.upcartRefreshCart !== 'function') {
                window.location.assign(config.cartUrl);
                return;
              }
              await window.upcartRefreshCart();
              cart = await getCart();
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            } catch (error) {
              status.textContent = succeeded ? config.strings.refresh : config.strings.error;
              if (succeeded) {
                const retry = make('a', 'retry', config.strings.refresh);
                retry.href = config.cartUrl;
                status.append(document.createElement('br'), retry);
                product.variants = [];
              }
            } finally {
              adding = false;
              button.textContent = config.strings.add;
              button.disabled = succeeded;
              render();
              if (queuedRefresh) { queuedRefresh = false; schedule(); }
            }
          });
        }
      }
    }
    async function refresh() {
      if (adding) { queuedRefresh = true; return; }
      if (request) { queuedRefresh = true; return; }
      request = getCart();
      try {
        cart = await request;
        mountPanels();
        render();
      } catch (error) {
        panels.forEach(panel => { panel.hidden = true; });
      } finally {
        request = null;
        if (queuedRefresh) { queuedRefresh = false; schedule(); }
      }
    }
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(refresh, 120);
    }
    function connect() {
      ['upcartSubscribeCartLoaded', 'upcartSubscribeCartOpened', 'upcartSubscribeCartUpdated'].forEach(name => {
        if (!subscribers.has(name) && typeof window[name] === 'function') {
          window[name](schedule);
          subscribers.add(name);
        }
      });
      mountPanels();
    }
    connect();
    let attempts = 0;
    const connectionTimer = setInterval(() => {
      connect();
      if (subscribers.size === 3 || ++attempts >= 40) clearInterval(connectionTimer);
    }, 250);
    document.addEventListener('cart:change', schedule);
    document.addEventListener('cart:refresh', schedule);
    document.addEventListener('click', event => {
      if (event.target.closest('a[href$="/cart"],button[aria-controls="cart-drawer"]')) { connect(); schedule(); }
    }, { passive: true });
    window.addEventListener('pageshow', schedule);
    if (document.querySelector('form.cart-page') || drawerRoot()) schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();
})();
